module.exports = __webpack_public_path__ + "static/media/63.96950e80.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/63.jpg
// module id = 623
// module chunks = 0